import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProfileInfo, ProfileNotification } from '../models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private http: HttpClient) {

  }

  async getProfileInfo(id : string = null): Promise<ProfileInfo> {
    if (!id)
        return await this.http.get<ProfileInfo>(`${environment.apiUrl}/ProfilePage-UserInfo/${id}`).toPromise();
    return await this.http.get<ProfileInfo>(`${environment.apiUrl}/ProfilePage-UserInfo/${id}`).toPromise();
  }


  async getProfileNotification(): Promise<{ workspaces: ProfileNotification[] }> {
    return await this.http.get<{ workspaces: ProfileNotification[] }>(`${environment.apiUrl}/ProfilePage-Notification`).toPromise();

  }
}

